import React from 'react';

const Equalizer = () => {
  return (
    <div className="flex gap-0.5 items-end h-3">
      <div className="w-0.5 bg-custom-green/80 animate-eq1 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq2 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq3 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq3 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq4 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq5 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq1 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq2 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq4 h-3 origin-bottom"></div>
      <div className="w-0.5 bg-custom-green/80 animate-eq5 h-3 origin-bottom"></div>
    </div>
  );
};

export default Equalizer;
